/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const searchRangeFilterDtoSchema = z.object({ "end": z.unknown().nullish(), "includeEmptyValues": z.boolean().nullish(), "name": z.string().nullish(), "start": z.unknown().nullish() });
export type SearchRangeFilterDto = z.infer<typeof searchRangeFilterDtoSchema>;
